<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col md="3" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Others
                                Info</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submitForm(currentStatus)" ref="" id="">
                                    <v-row class="pa-2">
                                        <v-col cols="12">
                                            <v-autocomplete 
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4" 
                                                v-model="workorder_id.value.value"
                                                :items="filteredWorkOrderList" 
                                                :item-title="(item) => `${item.code}`"
                                                item-value="id" 
                                                :error-messages="workorder_id.errorMessage.value" 
                                                autocomplete="off"
                                                readonly
                                                >
                                                <template #label>
                                                    Work Order
                                                </template>
                                            </v-autocomplete>

                                            <v-date-input 
                                                input-format="dd/mm/yyyy"
                                                label="Invoice Date" 
                                                density="compact" 
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar" 
                                                variant="outlined"
                                                bg-color="grey-lighten-4" 
                                                v-model="sale_invoice_date.value.value"
                                                :error-messages="sale_invoice_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable>
                                            </v-date-input>

                                            <v-autocomplete 
                                                variant="outlined" 
                                                density="compact"
                                                bg-color="grey-lighten-4" 
                                                v-model="order_category.value.value"
                                                :items="[{ name: 'general', display_text: 'General' }, { name: 'production', display_text: 'Production' }]"
                                                :item-title="(item) => `${item.display_text}`" 
                                                item-value="name"
                                                :error-messages="order_category.errorMessage.value" 
                                                autocomplete="off"
                                                readonly
                                                >
                                                <template #label>
                                                    Order Category
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete 
                                                variant="outlined" 
                                                density="compact"
                                                bg-color="grey-lighten-4" 
                                                v-model="customer_id.value.value"
                                                :items="getCustomerMapList"
                                                :item-title="item => `${item.customer.company_name}` ?? 'N/A'"
                                                item-value="customer_id"
                                                :error-messages="customer_id.errorMessage.value"
                                                autocomplete="off" 
                                                readonly
                                                >
                                                <template #label>
                                                    Customer Name
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-date-input 
                                                input-format="dd/mm/yyyy"
                                                label="Shipping Date" 
                                                density="compact"
                                                prepend-icon="" 
                                                prepend-inner-icon="mdi-calendar" 
                                                variant="outlined"
                                                bg-color="grey-lighten-4" 
                                                v-model="shipping_date.value.value"
                                                :error-messages="shipping_date.errorMessage.value" 
                                                autocomplete="off"
                                                readonly
                                                >
                                            </v-date-input>

                                            <v-text-field 
                                                label="Shipping / Delivery Address" 
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="delivery_address.value.value"
                                                :error-messages="delivery_address.errorMessage.value" 
                                                autocomplete="off"
                                                readonly
                                            >
                                            </v-text-field>

                                            <v-text-field 
                                                label="PO No" 
                                                density="compact"
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="po_no.value.value" 
                                                :error-messages="po_no.errorMessage.value"
                                                autocomplete="off" 
                                                clearable>
                                            </v-text-field>

                                            <v-date-input
                                                input-format="dd/mm/yyyy" 
                                                label="PO Date" 
                                                density="compact"
                                                prepend-icon="" 
                                                prepend-inner-icon="mdi-calendar" 
                                                variant="outlined"
                                                bg-color="grey-lighten-4" 
                                                v-model="po_date.value.value"
                                                :error-messages="po_date.errorMessage.value" 
                                                autocomplete="off"
                                                clearable
                                                >
                                            </v-date-input>

                                            <v-autocomplete 
                                                variant="outlined" 
                                                density="compact"
                                                bg-color="grey-lighten-4" 
                                                v-model="payment_bank_id.value.value"
                                                :items="getLcBankList" 
                                                :item-title="item => `${item.name}-${item.branch}` ?? 'N/A'"
                                                item-value="id" 
                                                :error-messages="payment_bank_id.errorMessage.value" 
                                                autocomplete="off"
                                                clearable>
                                                <template #label>
                                                    Payment Bank
                                                    <!-- <span class="text-red-accent-4">*</span> -->
                                                </template>
                                            </v-autocomplete>

                                            <v-textarea 
                                                label="Due Payment Terms (Days)" 
                                                variant="outlined"
                                                density="compact" 
                                                bg-color="grey-lighten-4" 
                                                rows="3"
                                                v-model="payment_terms.value.value"
                                                :error-messages="payment_terms.errorMessage.value"
                                                autocomplete="off"
                                                readonly
                                                >
                                            </v-textarea>

                                            <v-date-input 
                                                input-format="dd/mm/yyyy"
                                                label="Approximate Devliery Date" 
                                                density="compact"
                                                prepend-icon="" 
                                                prepend-inner-icon="mdi-calendar" 
                                                variant="outlined"
                                                bg-color="grey-lighten-4" 
                                                v-model="approximate_delivery_date.value.value"
                                                :error-messages="approximate_delivery_date.errorMessage.value" 
                                                autocomplete="off"
                                                readonly
                                                >
                                            </v-date-input>

                                            <v-text-field 
                                                label="Sale Invoice By" 
                                                density="compact" 
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="saleOrder_by.value.value"
                                                :error-messages="saleOrder_by.errorMessage.value" 
                                                autocomplete="off"
                                                :disabled="true" clearable>
                                            </v-text-field>

                                            <v-text-field 
                                                label="Sale Invoice By Mobile" 
                                                density="compact" 
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="saleOrder_by_mobile.value.value"
                                                :error-messages="saleOrder_by.errorMessage.value" 
                                                autocomplete="off"
                                                :disabled="true" 
                                                clearable>
                                            </v-text-field>

                                            <v-text-field 
                                                label="Sale Invoice By Email" 
                                                density="compact" 
                                                variant="outlined" 
                                                bg-color="grey-lighten-4"
                                                v-model="saleOrder_by_email.value.value"
                                                :error-messages="saleOrder_by_email.errorMessage.value" 
                                                :disabled="true"
                                                autocomplete="off" 
                                                clearable>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col md="9" cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Item
                                Info</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submitForm(currentStatus)" ref="" id="">
                                    <!-- <v-row class="pt-2 justify-center">
                                        <v-col cols="8">
                                            <v-autocomplete 
                                                label="Search Product Name" 
                                                variant="outlined"
                                                density="compact" 
                                                bg-color="grey-lighten-4"
                                                v-model="product_id.value.value" 
                                                :items="getProductMapList"
                                                :item-title="(item) => `${item.product.name}`" 
                                                item-value="product_id"
                                                :error-messages="product_id.errorMessage.value"
                                                @update:model-value="addCart" 
                                                @keydown.enter="addCart"
                                                autocomplete="off" 
                                                clearable>
                                            </v-autocomplete>

                                            <input v-model="sale_invoice_master_id.value.value" type="hidden" />
                                        </v-col>

                                        <v-col cols="1">
                                            <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                                        </v-col>
                                    </v-row> -->

                                    <!-- Cart Table -->
                                    <v-row class="pt-0">
                                        <v-col cols="12">
                                            <!-- <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom" style="height:40vh; overflow-y: scroll;"> -->
                                            <v-table density="compact" :loading="loading" fixed-header
                                                class="table-dotted-border-bottom">
                                                <!-- style="height:40vh; overflow-y: scroll;" -->
                                                <thead>
                                                    <tr>
                                                        <th class="text-center" style="width: 5%">SL</th>
                                                        <th class="text-center" style="width: 6%">Code</th>
                                                        <th class="text-left" style="width: 25%">
                                                            Product Name
                                                        </th>
                                                        
                                                        <th class="text-center" style="width: 6%">Desc.</th>
                                                        <th class="text-center" style="width: 6%">Lot No.</th>
                                                       
                                                        <th class="text-center" style="width: 6%">Unit</th>
                                                        
                                                        <th class="text-center" style="width: 6%">
                                                            Order Qty
                                                        </th>

                                                        <th class="text-center" style="width:6%">
                                                            Invoice Qty
                                                        </th>

                                                        <th v-if="isFreeItem" class="text-center" style="width:6%">
                                                            Free Qty
                                                        </th>

                                                        <th class="text-center" style="width: 10%">
                                                            Remaining Qty
                                                        </th>

                                                        <th class="text-center" style="width: 10%">
                                                            Already Invoiced Qty
                                                        </th>

                                                        <th class="text-center" style="width: 10%">
                                                            Price
                                                        </th>

                                                        <th class="text-center" style="width: 10%">
                                                            Amount
                                                        </th>


                                                        <th class="text-right" style="width: 5%">Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    <template v-for="(item, index) in cart" v-if="cart.length > 0"  :key="index">

                                                        <tr @click="isGiftItem ? (expandedIndex = expandedIndex === index ? null : index) : null"
                                                                style="cursor:pointer; background-color: #d3f2c5;">
                                                            <td class="text-center py-1">{{ index + 1 }}</td>
                                                            <td class="text-left py-1" style="white-space: normal">
                                                                {{ item.product_code }}
                                                            </td>
                                                            <td class="text-left py-1" style="white-space: normal">
                                                                <p style="width: 100px;">{{ item.product_name }}</p>
                                                            </td>
                                                            <td class="text-center py-1">
                                                                {{ item.description }}
                                                            </td>
                                                            <td class="text-center py-1">
                                                                {{ item.lot_no }}
                                                            </td>

                                                            <td class="text-center py-1">
                                                                {{ item.unit_name }}
                                                            </td>
                                                        
                                                            <td class="text-center py-1">
                                                                {{ this.$numberFormat(item.order_qty) }}
                                                            </td>


                                                            <td class="text-right py-2">
                                                                <v-text-field 
                                                                    :reverse="false" 
                                                                    controlVariant="stacked"
                                                                    style="width: 80px" 
                                                                    label="" :hideInput="false"
                                                                    :inset="false" 
                                                                    :min="1" 
                                                                    type="number" 
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    bg-color="grey-lighten-4"
                                                                    v-model="item.qty"
                                                                    hide-details
                                                                    @click.stop
                                                                    @focus.stop
                                                                    :error="item.qty < 1"
                                                                    :error-messages="item.qty < 1 ? 'Quantity must be greater than 0' : ''"
                                                                    @update:model-value="productCalculate(item)"
                                                                    @blur="productCalculate(item)"
                                                                    >
                                                                </v-text-field>
                                                            </td>

                                                            <td v-if="isFreeItem" class="text-left py-1">
                                                                <v-text-field 
                                                                    :reverse="false" 
                                                                    controlVariant="stacked"
                                                                    style="width: 80px" 
                                                                    label="" 
                                                                    :hideInput="false"
                                                                    :inset="false" 
                                                                    :min="1" 
                                                                    type="number" 
                                                                    density="compact"
                                                                    variant="outlined" 
                                                                    bg-color="grey-lighten-4"
                                                                    v-model="item.free_qty" 
                                                                    hide-details 
                                                                    @click.stop
                                                                    @focus.stop
                                                                    :error="item.free_qty < 0"
                                                                    :error-messages="item.free_qty < 0 ? 'Quantity must be greater than or equal 0' : ''"
                                                                    >
                                                                </v-text-field>
                                                            </td>

                                                            <td class="text-center py-1">
                                                                {{ this.$numberFormat(item.remaining_qty) }}
                                                            </td>

                                                            <td class="text-center py-1">
                                                                {{ this.$numberFormat(item.already_invoiced_qty) }}
                                                            </td>

                                                            <td class="text-center py-1">

                                                                <v-text-field 
                                                                    :reverse="false" 
                                                                    controlVariant="stacked"
                                                                    style="width: 80px" 
                                                                    label="" 
                                                                    :hideInput="false"
                                                                    :inset="false" 
                                                                    :min="1" 
                                                                    type="number" 
                                                                    density="compact"
                                                                    variant="outlined" 
                                                                    bg-color="grey-lighten-4"
                                                                    v-model="item.sale_rate" 
                                                                    hide-details 
                                                                    @click.stop
                                                                    @focus.stop
                                                                    :error="item.sale_rate < 0"
                                                                    :error-messages="item.sale_rate < 0 ? 'Rate must be greater than or equal 0' : ''"
                                                                    @update:model-value="productCalculate(item)"
                                                                    @blur="productCalculate(item)"
                                                                    >
                                                                </v-text-field>
                                                            </td>

                                                            <td class="text-center py-1">
                                                                {{ this.$numberFormat(item.total) }}
                                                            </td>

                                                            <td style="white-space: nowrap;" class="text-center py-1">
                                                                <v-icon size="small" color="red" class="delete-button"
                                                                    @click="removeFromCart(index)">
                                                                    mdi-delete
                                                                </v-icon>

                                                                <v-btn v-if="isGiftItem" icon variant="tonal" size="small" color="primary" class="pa-1 breakdown-input">
                                                                    <v-icon color="blue">mdi-gift-open</v-icon>
                                                                </v-btn>

                                                                <v-icon v-if="isGiftItem" size="small">
                                                                    {{ expandedIndex === index ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                                                                </v-icon>
                                                            </td>
                                                        </tr>

                                                        <tr class="pa-0" >
                                                            <td colspan="100%" class="pa-0" style="height: 0px;">
                                                                <v-expand-transition >
                                                                    <div v-if="expandedIndex === index" :key="'expand-' + index" class="d-flex flex-column">
                                                                        
                                                                            <v-table density="compact" :loading="loading" fixed-header
                                                                                class="table-dotted-border-bottom">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th class="text-center" style="width: 5%">SL</th>

                                                                                        <th class="text-left" style="width: 25%">
                                                                                            Product
                                                                                        </th>

                                                                                        <th class="text-center" style="width: 10%">Unit</th>

                                                                                        <th class="text-left" style="width: 10%">
                                                                                            Order Qty
                                                                                        </th>
                                                                                        <th class="text-left" style="width: 10%">
                                                                                            Qty
                                                                                        </th>

                                                                                        <th class="text-left" style="width: 15%">
                                                                                            Price
                                                                                        </th>

                                                                                        <th class="text-center" style="width: 15%">
                                                                                            Amount
                                                                                        </th>
                                                                                        <th class="text-center" style="width: 20%">
                                                                                            Desc.
                                                                                        </th>
                                                                                        <th class="text-center" style="width: 10%">
                                                                                            Lot No.
                                                                                        </th>
                                                                                        <th class="text-right" style="width: 5%">Action</th>
                                                                                    </tr>
                                                                                </thead>

                                                                                <tbody>
                                                                                    <!-- <tr v-if="item.gifts.length == 0" style="" >
                                                                                        <td colspan="100%">
                                                                                        <div style="width:100%; display:flex; justify-content:center; padding:20px;">
                                                                                            <v-btn  class="bg-primary pa-2" style="height:30px; font-size:12px;" variant="flat"  @click="addGiftItem(index)"> <v-icon color="white">mdi-plus</v-icon> Gift</v-btn>
                                                                                        </div>
                                                                                        </td>
                                                                                    </tr> -->
                                                                                    <template v-for="(giftItem, giftIndex) in item.gifts"  :key="giftIndex">
                                                                                        <tr v-if="item.gifts.length > 0" style="" >
                                                                                            <td class="text-center py-1">{{ giftIndex + 1 }}</td>

                                                                                            <td class="text-left py-1" style="white-space: normal">
                                                                                                <v-autocomplete 
                                                                                                    label="Product Name" 
                                                                                                    variant="outlined"
                                                                                                    density="compact" 
                                                                                                    bg-color="grey-lighten-4"
                                                                                                    v-model="giftItem.product_id"
                                                                                                    :items="getProductMapList"
                                                                                                    :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'" 
                                                                                                    item-value="product_id"
                                                                                                    autocomplete="off" 
                                                                                                    clearable
                                                                                                    hide-details 
                                                                                                    :error-messages="giftItem.errors?.product_id"
                                                                                                    @update:model-value="val => selectGiftItem(index, giftIndex, val)" 
                                                                                                >
                                                                                                </v-autocomplete>
                                                                                            </td>

                                                                                            <td class="text-center py-1">
                                                                                                {{ giftItem.unit_name }}
                                                                                            </td>

                                                                                             <td class="text-left py-1">{{ giftItem.order_qty }}</td>
                                                                                            <td class="text-left py-1">
                                                                                                <v-text-field 
                                                                                                    :reverse="false" 
                                                                                                    controlVariant="stacked"
                                                                                                    style="width: 80px" 
                                                                                                    label="" :hideInput="false"
                                                                                                    :inset="false" 
                                                                                                    :min="1" 
                                                                                                    type="number" 
                                                                                                    density="compact"
                                                                                                    variant="outlined" 
                                                                                                    bg-color="grey-lighten-4"
                                                                                                    v-model="giftItem.qty" 
                                                                                                    hide-details 
                                                                                                    :error="giftItem.qty < 0"
                                                                                                    :error-messages="giftItem.qty < 0 ? 'Rate must be greater than or equal 0' : ''"
                                                                                                    @update:model-value="giftItem.total = giftItem.qty * giftItem.qty"
                                                                                                    @blur="giftItem.total = giftItem.qty * giftItem.qty"
                                                                                                    >
                                                                                                </v-text-field>
                                                                                            </td>

                                                                                            <td class="text-left py-1">
                                                                                                <v-text-field 
                                                                                                    :reverse="false" 
                                                                                                    controlVariant="stacked"
                                                                                                    style="width: 120px" 
                                                                                                    label="" :hideInput="false"
                                                                                                    :inset="false" 
                                                                                                    :min="0" 
                                                                                                    type="number" 
                                                                                                    density="compact"
                                                                                                    variant="outlined" 
                                                                                                    bg-color="grey-lighten-4"
                                                                                                    v-model="giftItem.sale_rate" 
                                                                                                    hide-details 
                                                                                                    :error="giftItem.sale_rate < 0"
                                                                                                    :error-messages="giftItem.sale_rate < 0 ? 'Rate must be greater than or equal 0' : ''"
                                                                                                    @update:model-value="giftItem.total = giftItem.qty * giftItem.sale_rate"
                                                                                                    @blur="giftItem.total = giftItem.qty * giftItem.sale_rate"
                                                                                                    >
                                                                                                </v-text-field>
                                                                                            </td>

                                                                                            <td class="text-center py-1">
                                                                                                {{ this.$numberFormat(giftItem.total) }}
                                                                                            </td>

                                                                                            <td class="text-left py-1">
                                                                                                <v-text-field 
                                                                                                    :reverse="false" 
                                                                                                    controlVariant="stacked"
                                                                                                    style="width: 100px" 
                                                                                                    label="" 
                                                                                                    :hideInput="false"
                                                                                                    :inset="false" 
                                                                                                    type="text" 
                                                                                                    density="compact"
                                                                                                    variant="outlined" 
                                                                                                    bg-color="grey-lighten-4"
                                                                                                    v-model="giftItem.description" 
                                                                                                    >
                                                                                                </v-text-field>
                                                                                            </td>
                                                                                            <td class="text-left py-1">
                                                                                                <v-text-field 
                                                                                                    :reverse="false" 
                                                                                                    controlVariant="stacked"
                                                                                                    style="width: 80px" 
                                                                                                    label="" :hideInput="false"
                                                                                                    :inset="false" 
                                                                                                    type="text" 
                                                                                                    density="compact"
                                                                                                    variant="outlined" 
                                                                                                    bg-color="grey-lighten-4"
                                                                                                    v-model="giftItem.lot_no" 
                                                                                                    >
                                                                                                </v-text-field>
                                                                                            </td>
                                                                                            <td class="text-center py-1" style="width:200px;">
                                                                                                <div class="d-flex justify-content-center">
                                                                                                    <v-btn icon variant="tonal" size="small" color="primary" class="pa-1 breakdown-input" @click="removeGiftItem(index, giftIndex)">
                                                                                                        <v-icon color="red">mdi-close</v-icon>
                                                                                                    </v-btn>

                                                                                                    <v-btn v-if="giftIndex == item.gifts.length - 1" variant="tonal" icon size="small" color="primary" class="breakdown-input" @click="addGiftItem(index)">
                                                                                                        <v-icon color="blue">mdi-plus</v-icon>
                                                                                                    </v-btn>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </template >
                                                                                </tbody>
                                                                            </v-table>

                                                                    </div>
                                                                </v-expand-transition>
                                                            </td>
                                                        </tr>

                                                    </template>

                                                    <tr v-else-if="loading == true">
                                                        <td colspan="11" class="text-center">
                                                            <v-skeleton-loader type="heading" :loading="loading" />
                                                        </td>
                                                    </tr>

                                                    <tr v-else>
                                                        <td colspan="11" class="text-center text-red">
                                                            You have no item
                                                        </td>
                                                    </tr>



                                                </tbody>
                                                <!-- <tfoot v-if="cart.length > 0"> -->

                                                <tfoot>
                                                    <tr>
                                                        <th colspan="6"
                                                            class="bg-grey-lighten-1 text-right text-uppercase font-weight-bold py-1">
                                                            Sub Total
                                                        </th>

                                                        <th colspan="5" class="bg-grey-lighten-1"></th>

                                                        <th class="bg-grey-lighten-1 text-center font-weight-bold py-1">
                                                            {{ this.$numberFormat(subTotal) }}
                                                        </th>

                                                        <th colspan="4" class="bg-grey-lighten-1"></th>

                                                    </tr>

                                                    <tr>
                                                        <td colspan="6" class="text-right">
                                                            Discount (10 or 10%)
                                                        </td>

                                                        <td colspan="3" class=""></td>

                                                        <td colspan="3" class="text-right py-1">
                                                            <v-text-field 
                                                                v-model="discount_value.value.value"
                                                                density="compact" 
                                                                label="%" 
                                                                hide-details 
                                                                dense
                                                                autocomplete="off" 
                                                                variant="outlined"
                                                                readonly 
                                                            />
                                                        </td>

                                                        <td class="text-center">
                                                            {{ this.$numberFormat(discountAmount) }}
                                                        </td>

                                                        <td class="text-center py-1"></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="6" class="text-right py-1">
                                                            Tax (10 or 10%)
                                                        </td>

                                                        <td colspan="3" class="text-right py-1">
                                                            <div class="d-flex justify-end">
                                                                <v-select 
                                                                    v-model="taxType" 
                                                                    density="compact"
                                                                    variant="outlined" 
                                                                    :items="includeOrExclude"
                                                                    item-title="label" 
                                                                    item-value="value" 
                                                                    hide-details
                                                                    style="min-width: 140px"
                                                                    readonly
                                                                    >
                                                                </v-select>
                                                            </div>
                                                        </td>

                                                        <td colspan="3" class="text-right py-1">
                                                            <v-text-field 
                                                            v-model="tax_value.value.value"  
                                                            density="compact" 
                                                            label="%" 
                                                            hide-details 
                                                            dense
                                                            autocomplete="off" 
                                                            variant="outlined" 
                                                            :disabled="taxTypeDisable"
                                                            />
                                                        </td>

                                                        <td class="text-center">
                                                            {{ this.$numberFormat(taxAmount) }}
                                                        </td>

                                                        <td colspan="4" class="text-center py-1"></td>
                                                    </tr>

                                                    <tr>
                                                         <td colspan="6" class="text-right py-1">
                                                            Vat (10 or 10%)
                                                        </td>
                                          
                                                        <td colspan="3" class="text-right py-1">
                                                            <div class="d-flex justify-end">
                                                                <v-select 
                                                                    v-model="vatType" 
                                                                    density="compact"
                                                                    variant="outlined" 
                                                                    :items="includeOrExclude"
                                                                    item-title="label" 
                                                                    item-value="value" 
                                                                    hide-details
                                                                    style="max-width: 140px"
                                                                    readonly
                                                                    >
                                                                </v-select>
                                                            </div>
                                                        </td>

                                                        <td colspan="3" class="text-right py-1">
                                                            <v-text-field 
                                                                v-model="vat_value.value.value"
                                                                density="compact" 
                                                                label="%" hide-details dense
                                                                autocomplete="off" 
                                                                variant="outlined" 
                                                                :disabled="vatTypeDisable"
                                                            />
                                                        </td>

                                                        <td class="text-center">
                                                            {{ this.$numberFormat(vatAmount) }}
                                                        </td>
                                                        <td colspan="4"></td>
                                                    </tr>

                                                    <tr>
                                                        <th colspan="6"
                                                            class="bg-grey-lighten-1 text-right text-uppercase font-weight-bold py-1">
                                                            Grand Total
                                                        </th>
                                                        <th colspan="5" class="bg-grey-lighten-1 text-right py-1"></th>
                                                        <th class="bg-grey-lighten-1 text-center font-weight-bold py-1">
                                                            {{ this.$numberFormat(grandTotal) }}
                                                        </th>
                                                        <th colspan="4" class="bg-grey-lighten-1"></th>
                                                    </tr>
                                                </tfoot>
                                            </v-table>
                                        </v-col>
                                    </v-row>
                                    <v-divider></v-divider>
                                    <v-row class="pt-0">
                                        <v-col cols="6">
                                            <v-card class="mt-0 elevation-0 rounded-0">
                                                <v-card-title
                                                    class="d-flex align-center py-2 px-4 bg-blue-grey-lighten-5"
                                                    style="font-size: 1.1rem;">
                                                    <span class="">Payment</span>
                                                </v-card-title>
                                                <v-divider></v-divider>
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col cols="5" sm="5" md="5">
                                                            Payment Type
                                                        </v-col>
                                                        <v-col cols="7" sm="7" md="7">
                                                            <v-select 
                                                                v-model="paymentType" 
                                                                :items="paymentTypes"
                                                                item-title="label" 
                                                                item-value="value" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                hide-details
                                                                autocomplete="off"
                                                                readonly
                                                                >
                                                            </v-select>
                                                        </v-col>
                                                        <v-col v-if="paymentType === 'bank'" cols="5" sm="5" md="5">
                                                            Bank Name
                                                        </v-col>
                                                        <v-col v-if="paymentType === 'bank'" cols="7" sm="7" md="7">
                                                            <v-autocomplete 
                                                                v-model="bankName" 
                                                                :items="banks"
                                                                item-title="label" 
                                                                item-value="value" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                hide-details 
                                                                autocomplete="off" 
                                                                readonly
                                                            />
                                                        </v-col>
                                                        <v-col v-if="paymentType === 'bank'" cols="5" sm="5" md="5">
                                                            Account No
                                                        </v-col>
                                                        <v-col v-if="paymentType === 'bank'" cols="7" sm="7" md="7">
                                                            <v-text-field 
                                                                v-model="accountNo" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                hide-details
                                                                autocomplete="off"
                                                                readonly
                                                            />
                                                        </v-col>
                                                        <v-col v-if="paymentType === 'bank'" cols="5" sm="5" md="5">
                                                            Cheque No
                                                        </v-col>
                                                        <v-col v-if="paymentType === 'bank'" cols="7" sm="7" md="7">
                                                            <v-text-field 
                                                                label="Cheque No" 
                                                                density="compact"
                                                                v-model="chequeNo" 
                                                                variant="outlined" 
                                                                hide-details
                                                                autocomplete="off" 
                                                                readonly
                                                                />
                                                        </v-col>
                                                        <v-col v-if="paymentType === 'bank'" cols="5" sm="5" md="5">
                                                            Cheque Issue Date
                                                        </v-col>
                                                        <v-col v-if="paymentType === 'bank'" cols="7" sm="7" md="7">
                                                            <v-date-input 
                                                                input-format="dd/mm/yyyy"
                                                                label="Cheque Issue Date" 
                                                                density="compact"
                                                                prepend-icon="" 
                                                                prepend-inner-icon="mdi-calendar"
                                                                v-model="cheque_issue_date" 
                                                                variant="outlined"
                                                                hide-details 
                                                                autocomplete="off"
                                                                readonly
                                                                ></v-date-input>
                                                        </v-col>
                                                        <!-- <v-col v-if="paymentType === 'mobile_banking'" cols="5" sm="5" md="5">
                                                            Provider
                                                        </v-col>
                                                        <v-col v-if="paymentType === 'mobile_banking'" cols="7" sm="7" md="7">
                                                            <v-autocomplete 
                                                                v-model="mobileProvider"
                                                                :items="mobileProviders" 
                                                                item-title="label"
                                                                item-value="value" 
                                                                density="compact" 
                                                                variant="outlined"
                                                                hide-details 
                                                                autocomplete="off"
                                                                readonly
                                                            ></v-autocomplete>
                                                        </v-col>

                                                        <v-col v-if="paymentType === 'mobile_banking'" cols="5" sm="5" md="5">
                                                            Transaction ID
                                                        </v-col>

                                                        <v-col v-if="paymentType === 'mobile_banking'" cols="7" sm="7" md="7">
                                                            <v-text-field v-model="transactionId" density="compact"
                                                                variant="outlined" hide-details autocomplete="off" readonly />
                                                        </v-col> -->
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-card class="mt-0 elevation-0 rounded-0">
                                                <!-- <v-card-title class="d-flex align-center py-2 px-4 bg-blue-grey-lighten-5" style="font-size: 1.1rem;">
                                                    <span class="">Payment</span>
                                                </v-card-title> -->
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col cols="6" sm="6" md="6">
                                                            Advance Payment
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-text-field v-model="paid.value.value" 
                                                                density="compact"
                                                                label="Payment Received" 
                                                                type="number" 
                                                                hide-details
                                                                variant="outlined"
                                                                @update:model-value="onChangePayReceived" 
                                                                readonly
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            Previous Due
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-text-field 
                                                                v-model="previous_due.value.value" 
                                                                density="compact"
                                                                label="Previous Due" 
                                                                type="number" 
                                                                hide-details
                                                                readonly
                                                                variant="outlined" 
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            Total Due
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-text-field 
                                                                v-model="due.value.value" 
                                                                density="compact"
                                                                label="Total Due" 
                                                                type="number" 
                                                                hide-details
                                                                readonly
                                                                variant="outlined" />
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            Next Payment Date
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-date-input 
                                                                input-format="dd/mm/yyyy"
                                                                label="Next Payment Date" 
                                                                density="compact" 
                                                                prepend-icon=""
                                                                prepend-inner-icon="mdi-calendar" 
                                                                variant="outlined"
                                                                v-model="next_payment_date.value.value"
                                                                :error-messages="next_payment_date.errorMessage.value"
                                                                autocomplete="off"
                                                                readonly
                                                                clearable>
                                                            </v-date-input>
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            Next Payment Approx. Amount
                                                        </v-col>
                                                        <v-col cols="6" sm="6" md="6">
                                                            <v-text-field v-model="next_payment_amount.value.value" density="compact"
                                                                type="number" hide-details variant="outlined" readonly />
                                                            <input v-model="sale_invoice_master_id.value.value" type="hidden" />
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>

                                    <!-- Close Cart Table -->

                                    <v-divider></v-divider>

                                    <v-card-actions>
                                        <v-row class="pt-2">
                                            <v-col cols="8">
                                                <v-textarea label="Description" density="compact" variant="outlined"
                                                    bg-color="grey-lighten-4" v-model="remarks.value.value"
                                                    :error-messages="remarks.errorMessage.value" autocomplete="off"
                                                    rows="3" clearable></v-textarea>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-layout class="justify-end">
                                                    <!-- <v-btn class="bg-grey-darken-1 me-2" variant="flat"
                                                        @click="submitForm(0)">DRAFT</v-btn> -->
                                                    <v-btn class="bg-primary" variant="flat"
                                                        @click="submitForm(1)">Submit</v-btn>
                                                </v-layout>
                                            </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { nextTick, getCurrentInstance, ref, reactive } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";
import { getCompanyInfo } from '@/plugins/helpers'

export default {
    components: {},
    data: () => ({
        isGiftItem:false,
        isFreeItem:false,
        expandedIndex: null,
        panel: [0],
        panel2: [0],
        loading: false,
        errorMessages: "",
        isEntryMode: true,
        visible: false,
        search: "",
        selectedImage: null,
        photo_imageFile: "",
        preview: "/src/assets/no_preview.png",
        cart: [],

        vatTypeDisable: false,
        taxTypeDisable: false,

        vatType: 'include',
        taxType: 'include',
        includeOrExclude: [
            { value: 'include', label: "Include" },
            { value: 'exclude', label: "Exclude" },
            { value: 'exempted', label: "Exempted" },
        ],
        paymentType: null,
        bankName: null,
        accountNo: "",
        mobileProvider: null,
        transactionId: "",
        paymentTypes: [
            { label: "Cash", value: "cash" },
            { label: "Bank", value: "bank" },
            { label: "Mobile Banking", value: "mobile_banking" }
        ],
        banks: [
            { label: "Al Rajhi Bank", value: "alrajhi" },
            { label: "NCB", value: "ncb" },
            { label: "Riyad Bank", value: "riyad" }
        ],
        mobileProviders: [
            { label: "Bkash", value: "bkash" },
            { label: "Nagad", value: "nagad" },
            { label: "Rocket", value: "rocket" }
        ]
    }),
    watch: {
        vatType(val) {
            if (val === 'exempted') {
                this.vat_value.value.value = 0,
                this.vatTypeDisable = true;
            } else {
                this.vatTypeDisable = false;
            }
        },
        taxType(val) {
            if (val === 'exempted') {
                this.tax_value.value.value = 0,
                this.taxTypeDisable = true;
            } else {
                this.taxTypeDisable = false;
            }
        },
        grandTotal(newVal) {
            this.due.value.value = (parseFloat(newVal || 0) + parseFloat(this.previous_due.value.value)) - parseFloat(this.paid.value.value);
        }
    },
    created() {
        if (this.$store.getters.getLcBankList.length === 0) {
            this.$store.dispatch("getLcBankList");
        }
        if (this.$store.getters.getCustomerMapList.length === 0) {
            this.$store.dispatch("getCustomerMapList");
        }
        if (this.$store.getters.getProductMapList.length === 0) {
            this.$store.dispatch("getProductMapList");
        }
        if (this.$store.getters.getSalesWorkOrderList.length === 0) {
            this.$store.dispatch("getSalesWorkOrderList");
        }
    },
    computed: {
        getLcBankList() {
            return this.$store.getters.getLcBankList;
        },
        subTotal() {
            return this.cart.reduce((sum, item) => +sum + +item.total, 0);
        },

        discountAmount() {
            if (!this.discount_value?.value.value) {
                this.discount_value.value.value = 0;
                this.discount_method.value.value = 'flat';
                return 0;
            } 

            const val = this.discount_value.value.value.toString().trim();
            if (val.endsWith("%")) {
                this.discount_method.value.value = 'percent';
                const percentage = parseFloat(val.replace("%", ""));
                return (this.subTotal * percentage) / 100 || 0;
            }
            return parseFloat(val) || 0;
        },
        taxAmount() {
            if (!this.tax_value?.value.value) {
                this.tax_value.value.value = 0;
                this.tax_method.value.value = 'flat';
                return 0;
            } 

            const val = this.tax_value.value.value.toString().trim();
            if (val.endsWith("%")) {
                this.tax_method.value.value = 'percent';
                const percentage = parseFloat(val.replace("%", ""));
                return (this.subTotal * percentage) / 100 || 0;
            }
            return parseFloat(val) || 0;
        },
        vatAmount() {
            if (!this.vat_value.value.value) {
                this.vat_value.value.value = 0;
                this.vat_method.value.value = 'flat';
                return 0;
            } 

            const val = this.vat_value.value.value.toString().trim();
            if (val.endsWith("%")) {
                this.vat_method.value.value = 'percent';
                const percentage = parseFloat(val.replace("%", ""));
                return (this.subTotal * percentage) / 100 || 0;
            }
            return parseFloat(val) || 0;
        },
        grandTotal() {
            const discount = this.discountAmount;
            const vat = this.vatType === 'include' ? this.vatAmount : 0;
            const tax = this.taxType === 'include' ? this.taxAmount : 0;
            return this.subTotal + vat + tax - discount;
        },

        branchId() {
            return this.$store.getters.getAuthUser.branch_id || null;
        },

        getProductMapList() {
            let products = this.$store.getters.getProductMapList;
            return products.filter(
                (item) => item.branch_id == this.branchId && item.status == 1
            );
        },
        getCustomerMapList() {
            return this.$store.getters.getCustomerMapList;
        },
        filteredWorkOrderList() {
            const workorders = this.$store.getters.getSalesWorkOrderList || [];
            return workorders.filter(
                (item) => item.branch_id == this.branchId && item.status == 1
            );
        },
    },
    methods: {
        productCalculate(item) {
            if(item.qty > (+item.order_qty - +item.already_invoiced_qty)) {
                item.qty = +item.order_qty - +item.already_invoiced_qty 
            }
            item.remaining_qty = +item.order_qty - +item.already_invoiced_qty - +item.qty;
            item.total = item.qty * item.sale_rate
        },
        removeFromCart(index) {
            if (confirm("Are You Sure?")) {
                this.cart.splice(index, 1);
            }
        },
        cartReset() {
            this.product_id.value.value = null;
        },
        onChangePayReceived() {
            this.due.value.value = (parseFloat(this.grandTotal || 0) + parseFloat(this.previous_due.value.value)) - parseFloat(this.paid.value.value);
        },
        async orderLoad(selectedId) {

            if (!selectedId) {
                this.order_category.value.value = null;
                this.cart = [];
                return;
            }

            try {
                const data = await this.$store.dispatch("getSaleOrderProcessById", selectedId);
               
                const order = data; 
                this.sale_order_id.value.value = order.id
                this.customer_id.value.value = order.customer_id
                this.ref_no.value.value = order.ref_no || "";
                this.po_no.value.value = order.po_no || "";
                this.po_date.value.value = order.po_date ||null;
                this.sale_invoice_date.value.value = new Date();
                this.sale_order_date.value.value = order.sale_order_date ? new Date(order.sale_order_date) : new Date();
                this.shipping_date.value.value = order.shipping_date ? new Date(order.shipping_date) : new Date();
                this.approximate_delivery_date.value.value = order.approximate_delivery_date ? new Date(order.approximate_delivery_date) : new Date();
                this.payment_terms.value.value = order.payment_terms;
                this.delivery_address.value.value = order.delivery_address;
                this.ref_no.value.value = order.ref_no;
                this.order_category.value.value = order.order_category;
                this.workorder_id.value.value = order.workorder_id;
                this.employee_id.value.value = order.employee_id;
                
                this.discount_method.value.value = order.discount_method;
                this.discount_value.value.value = this.discount_method.value.value == 'percent'? order.discount_value + '%' : order.discount_value;

                this.tax_method.value.value = order.tax_method;
                this.tax_value.value.value = this.tax_method.value.value == 'percent'? order.tax_value + '%' : order.tax_value;
                this.taxType = order.tax_type;

                this.vat_method.value.value = order.vat_method;
                this.vat_value.value.value = this.vat_method.value.value == 'percent'? order.vat_value + '%' : order.vat_value;
                this.vatType = order.vat_type;

                this.paid.value.value = order.paid;
                this.previous_due.value.value = order.previous_due;
                this.due.value.value = order.due;
                this.next_payment_date.value.value = order.next_payment_date ? new Date(order.next_payment_date) : new Date();
                this.next_payment_amount.value.value = order.next_payment_amount;
                this.status.value.value = order.status;
                this.product_id.value.value = null;
                this.cart.value = [];

                (order.details || []).forEach((item) => {
                    if(item.quantity > item.already_invoiced_qty) {
                        this.cart.push({
                            product_id: item.product_id,
                            product_name: item.product?.name || "",
                            product_code: item.product?.code || "",
                            order_qty: item.quantity,
                            free_qty:item.free_qty,
                            description: item.description,
                            lot_no:item.lot_no,
                            free_qty:item.free_qty,
                            qty: item.quantity,
                            remaining_qty: item.quantity - item.already_invoiced_qty,
                            already_invoiced_qty: item.already_invoiced_qty,
                            unit_id: item.product?.unit_id || "",
                            unit_name: item.product?.unit?.name || "",
                            purchase_rate: item.purchase_rate,
                            sale_rate: item.sale_rate,
                            total: item.total,
                            gifts: (item.gifts || []).map(g => ({
                                product_id: g.product_id,
                                order_qty: g.quantity || 1,
                                already_invoiced_qty: 0,
                                remaining_qty: g.quantity || 1,
                                qty: g.quantity || 1,
                                sale_rate: g.sale_rate || 0,
                                description: g.description || '',
                            }))
                        });
                    }
                });
                this.paymentType = order?.voucher_master?.payment_method.toLowerCase();
                this.bankName = order?.voucher_master?.issuing_bank_name;
                this.accountNo = order?.voucher_master?.issuing_bank_account_no;
                this.chequeNo = order?.voucher_master?.cheque_no;
                this.cheque_issue_date = order?.voucher_master?.cheque_date;

                this.$store.commit("UNSET_LOADING");
            } catch (error) {
                console.error("Failed to load requisition data:", error);
            }
        },
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                sale_invoice_date: yup.date().required().label("Sale Invoice Date"),
                shipping_date: yup.date().nullable().label("Shipping Date"),
                approximate_delivery_date: yup.date().nullable().label("Approximate Delivery Date"),
                delivery_address: yup.string().nullable().label('Address'),
                ref_no: yup.string().nullable().label('ref no'),
                po_no: yup.string().nullable().label('PO No'),
                po_date: yup.date().nullable().label("PO Date"),
                order_category: yup.string().required().label("Order Category"),
                workorder_id: yup.number().positive().integer().nullable().label("Work Order"),
                customer_id: yup.number().positive().integer().required().label("Customer Name"),
                // cart: yup.array().of(
                //     yup.object().shape({
                //         product_id: yup.number().positive().integer().required("Product is required"),
                //         qty: yup.number().positive().integer().required("Quantity is required").min(1, "Quantity must be at least 1"),
                //         sale_rate: yup.number().positive().required("Sale Rate is required"),
                //     })
                // ).min(1, "At least one product must be added to the cart"),
            }),
        });

        const product_id = useField("product_id");
        const sale_invoice_master_id = useField("sale_invoice_master_id");
        const sale_order_id = useField("sale_order_id");
        const employee_id = useField("employee_id");
        const order_category = useField("order_category");
        const workorder_id = useField("workorder_id");
        const customer_id = useField("customer_id");
        const shipping_date = useField("shipping_date");
        const approximate_delivery_date = useField("approximate_delivery_date");
        const delivery_address = useField("delivery_address");
        const ref_no = useField("ref_no");
        const payment_terms = useField("payment_terms");

        const discount_value = useField("discount_value");
        const discount_method = useField("discount_method");
        const discount_amount = useField("discount_amount");
        const po_no = useField("po_no");
        const po_date = useField("po_date");
        const payment_bank_id = useField("payment_bank_id");
        const tax_amount = useField("tax_amount");
        const tax_value = useField("tax_value");
        const tax_type = useField("tax_type");
        const tax_method = useField("tax_method");
        const vat_amount = useField("vat_amount");
        const vat_value = useField("vat_value");
        const vat_type = useField("vat_type");
        const vat_method = useField("vat_method");

        const status = useField("status");

        const sale_invoice_date = useField("sale_invoice_date");
        const sale_order_date = useField("sale_order_date");
        const saleOrder_by = useField("saleOrder_by");
        const saleOrder_by_mobile = useField("saleOrder_by_mobile");
        const saleOrder_by_email = useField("saleOrder_by_email");
        const total = useField("total");
        const paid = useField('paid');
        const previous_due = useField('previous_due');
        const due = useField('due');
        const next_payment_date = useField('next_payment_date');
        const next_payment_amount = useField('next_payment_amount');
        const remarks = useField("remarks");
        const errorMessages = ref("");
        const cart = ref([]);
        const loading = ref("");
        const buttonText = ref("");
        buttonText.value = "Save";

        // const productErrors = reactive({});

        const store = useStore();
        const router = useRouter();

        // const validateProductField = (index, field, value) => {
        //     if (!productErrors[index]) {
        //         productErrors[index] = {};
        //     }
        //     productErrors[index][field] = "";
        //     switch (field) {
        //         case "qty":
        //         if (value && value >= 1) {
        //             productErrors[index][field] =
        //             "Input must be more than 1 or 1";
        //         } else if (value === '' || !value) {
        //             productErrors[index][field] =
        //             "Input is required"
        //         }
        //         break;
        //     }
        // };

        // const getProductError = (index, field) => {
        //   return productErrors[index] && productErrors[index][field] ? [productErrors[index][field]] : [];
        // };

        // const validateAllContacts = () => {
        //   let isValid = true;
        //   contacts.value.forEach((contact, index) => {
        //     validateContactField(index, "name", contact.name);
        //         // Check if there are any errors for this contact
        //         if (contactErrors[index]) {
        //             Object.values(contactErrors[index]).forEach((error) => {
        //             if (error) isValid = false;
        //             });
        //         }
        //     });
        //     return isValid;
        // };


        const currentStatus = ref(0);

        const submitForm = (status) => {
            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => {
            values.status = currentStatus.value;
            values.sub_total = proxy.subTotal;
            values.discount_amount = proxy.discountAmount;
            
            values.tax_amount = proxy.taxAmount;
            values.tax_type = proxy.taxType;

            values.vat_amount = proxy.vatAmount;
            values.vat_type = proxy.vatType;

            values.total = proxy.grandTotal;

            values.cart = cart.value;
            values.sale_invoice_date = formattedDate(sale_invoice_date.value.value);
            values.sale_order_date = formattedDate(sale_order_date.value.value);
            values.shipping_date = formattedDate(shipping_date.value.value);
            values.approximate_delivery_date = formattedDate(approximate_delivery_date.value.value);
            values.po_date = formattedDate(po_date.value.value);
            values.delivery_address = delivery_address.value.value;
            values.ref_no = ref_no.value.value;
            values.paid = paid.value.value;
            values.previous_due = previous_due.value.value;
            values.due = due.value.value;
            values.next_payment_date = formattedDate(next_payment_date.value.value);
            values.next_payment_amount = next_payment_amount.value.value;

            store.dispatch("saveUpdateSaleInvoice", values)
                .then((response) => {
                    resetForm();
                    buttonText.value = "Save";
                    cart.value = [];
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    setTimeout(() => {
                        router.push({ name: "sale-invoice-record" });
                    }, 2000);
                })
                .catch((error) => {
                     if (error.response && error.response.data && error.response.data.errors) {
                        const errors = error.response.data.errors;

                        cart.value.forEach(item => {
                            item.errors = {};
                        });

                        let expandedRows = [];

                        Object.keys(errors).forEach((key) => {
                            const message = errors[key][0];

                            // cart.0.qty OR cart.0.gifts.1.qty
                            const match = key.match(/cart\.(\d+)(?:\.gifts\.(\d+))?\.(.+)/);

                            if (match) {
                                const cartIndex = parseInt(match[1]);
                                const giftIndex = match[2] !== undefined ? parseInt(match[2]) : null;
                                const field = match[3];

                                if (!cart.value[cartIndex]) return;

                                if (giftIndex === null) {
                                    if (!cart.value[cartIndex].errors) {
                                        cart.value[cartIndex].errors = {};
                                    }

                                    cart.value[cartIndex].errors[field] = message;

                                    expandedRows.push(cartIndex);
                                }

                                else {
                                    if (!cart.value[cartIndex].gifts[giftIndex].errors) {
                                        cart.value[cartIndex].gifts[giftIndex].errors = {};
                                    }

                                    cart.value[cartIndex].gifts[giftIndex].errors[field] = message;

                                    expandedRows.push(cartIndex);
                                }
                            }
                        });

                        if (expandedRows.length > 0) {
                            proxy.expandedIndex = expandedRows[0];
                        }

                        const messages = Object.values(errors).flat().join('\n');
                        toast.error(messages);

                    } else {
                        toast.error(error.response?.data?.message || 'Something went wrong');
                    }      
                });
        });

        return {
            submitForm,
            submit,
            product_id,
            sale_order_id,
            sale_invoice_date,
            sale_order_date,
            shipping_date,
            approximate_delivery_date,
            delivery_address,
            ref_no,
            payment_terms,
            remarks,

            discount_value,
            discount_method,
            discount_amount,

            tax_amount,
            tax_value,
            tax_method,
            tax_type,

            po_no,
            po_date,
            payment_bank_id,

            vat_amount,
            vat_value,
            vat_method,
            vat_type,

            status,
            total,
            paid,
            previous_due,
            due,
            next_payment_date,
            next_payment_amount,
            cart,
            saleOrder_by,
            saleOrder_by_mobile,
            saleOrder_by_email,
            errorMessages,
            employee_id,
            order_category,
            workorder_id,
            customer_id,
            sale_invoice_master_id,
            buttonText,
            loading,
            getCompanyInfo,
            // productErrors,
            // validateProductField
        };
    },

    mounted() {
        this.isGiftItem = getCompanyInfo()?.is_gift_item ?? false;
        this.isFreeItem = getCompanyInfo()?.is_free_item ?? false;
        
        this.employee_id.value.value = "";
        let user = this.$store.getters.getAuthUser;
        this.saleOrder_by.value.value = user.full_name;
        this.saleOrder_by_mobile.value.value = user.mobile;
        this.saleOrder_by_email.value.value = user.email;
        
        const orderId = this.$route.query.order_id;
       
        if(orderId && this.isEntryMode == true) {
            this.orderLoad(Number(orderId));
        }

        const id = this.$route.query.id;

        if (id) {
            this.$store.commit("SET_LOADING", { color: "primary" });

            this.$nextTick(() => {
                this.$store
                    .dispatch("getSaleInvoiceById", id)
                    .then((data) => {
                        this.isEntryMode = false;
                        let saleInvoice = data;
                        this.sale_invoice_master_id.value.value = saleInvoice.id;
                        this.sale_order_id.value.value = saleInvoice.sale_order_id;
                        
                        this.sale_invoice_date.value.value = saleInvoice.sale_invoice_date ? new Date(saleInvoice.sale_invoice_date) : new Date();
                        this.sale_order_date.value.value = saleInvoice.sale_order_date ? new Date(saleInvoice.sale_order_date) : new Date();
                        this.shipping_date.value.value = saleInvoice.shipping_date ? new Date(saleInvoice.shipping_date) : new Date();
                        this.approximate_delivery_date.value.value = saleInvoice.sale_order.approximate_delivery_date ? new Date(saleInvoice.sale_order.approximate_delivery_date) : new Date();
                        this.delivery_address.value.value = saleInvoice.delivery_address;
                        this.payment_terms.value.value = saleInvoice.sale_order.payment_terms;
                        this.ref_no.value.value = saleInvoice.sale_order.ref_no;
                        this.po_no.value.value = saleInvoice.po_no;
                        this.order_category.value.value = saleInvoice.order_category;
                        this.workorder_id.value.value = saleInvoice.workorder_id;
                        this.employee_id.value.value = saleInvoice.employee_id;

                        this.po_date.value.value = saleInvoice.po_date;
                        this.payment_bank_id.value.value = saleInvoice.payment_bank_id;

                        this.discount_method.value.value = saleInvoice.discount_method;
                        this.discount_value.value.value = this.discount_method.value.value == 'percent'? saleInvoice.discount_value + '%' : saleInvoice.discount_value;

                        this.tax_method.value.value = saleInvoice.tax_method;
                        this.tax_value.value.value = this.tax_method.value.value == 'percent'? saleInvoice.tax_value + '%' : saleInvoice.tax_value;
                        this.taxType = saleInvoice.tax_type;
                        this.paymentType = saleInvoice?.sale_order?.voucher_master?.payment_method.toLowerCase();
                        this.bankName = saleInvoice?.sale_order?.voucher_master?.issuing_bank_name;
                        this.chequeNo = saleInvoice?.sale_order?.voucher_master?.cheque_no;
                        this.accountNo = saleInvoice?.sale_order?.voucher_master?.issuing_bank_account_no;
                        this.cheque_issue_date = saleInvoice?.sale_order?.voucher_master?.cheque_date;

                        this.vat_method.value.value = saleInvoice.vat_method;
                        this.vat_value.value.value = this.vat_method.value.value == 'percent'? saleInvoice.vat_value + '%' : saleInvoice.vat_value;
                        this.vatType = saleInvoice.vat_type;

                        this.paid.value.value = saleInvoice.paid;
                        this.previous_due.value.value = saleInvoice.previous_due;
                        this.due.value.value = saleInvoice.due;
                        this.next_payment_date.value.value = saleInvoice.next_payment_date ? new Date(saleInvoice.next_payment_date) : new Date();
                        this.next_payment_amount.value.value = saleInvoice.next_payment_amount;
                        this.status.value.value = saleInvoice.status;
                        this.product_id.value.value = null;
                        this.customer_id.value.value = saleInvoice.customer_id;
                        this.cart.value = [];

                        // Insert items one by one
                        (saleInvoice.details || []).forEach((item) => {
                            this.cart.push({ 
                                product_id: item.product_id,
                                product_name: item.product?.name || "",
                                product_code: item.product.product_code,
                                order_qty: item.order_qty,
                                free_qty:item.free_qty,
                                qty: item.qty,
                                remaining_qty: item.remaining_qty,
                                already_invoiced_qty: item.already_invoiced_qty,
                                unit_id: item.product.unit_id || "",
                                unit_name: item.product.unit?.name || "",
                                purchase_rate: item.purchase_rate,
                                sale_rate: item.sale_rate,
                                total: item.total,
                                gifts: (item.gifts || []).map(g => ({
                                    product_id: g.product_id,
                                    order_qty: g.qty || 1,
                                    already_invoiced_qty: g.already_invoiced_qty || 1,
                                    remaining_qty: g.remaining_qty || 1,
                                    qty: g.qty || 1,
                                    sale_rate: g.sale_rate || 0,
                                    description: g.description || '',
                                }))
                            });
                        });
                        this.remarks.value.value = saleInvoice.remarks ? saleInvoice.remarks : "";
                        this.$store.commit("UNSET_LOADING");
                    })
                    .catch((error) => {
                        this.$store.commit("UNSET_LOADING");
                        console.error("Failed to fetch rfq:", error);
                    });
            });
        } else {
            this.sale_invoice_master_id.value.value = "";
            this.sale_invoice_date.value.value = new Date();
            this.shipping_date.value.value = new Date();
            this.sale_order_id.value.value = new Date();
            this.payment_bank_id.value.value = null;
            // this.sale_order_date.value.value = new Date();
            // this.approximate_delivery_date.value.value = new Date();
            // this.next_payment_date.value.value = new Date();
            // this.next_payment_amount.value.value = 0;
            // this.paid.value.value = 0;
            // this.previous_due.value.value = 0;
            // this.due.value.value = 0;
            // this.isEntryMode = true;
        }
    },
};
</script>
